module.exports = __webpack_public_path__ + "static/media/weixiushigukaohebiaozhun1.e485cb1f.png";